import { render } from "./MaterialBadge.vue?vue&type=template&id=df2892bc"
import script from "./MaterialBadge.vue?vue&type=script&lang=js"
export * from "./MaterialBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__